import React from 'react';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import GradesTableStoreProvider from './store/GradesTableStoreProvider';
import useGradesTableData from './hooks/useGradesTableData';
import { AssignmentsBasedGradesTableProps } from './types';
import Navigation from './Navigation';
import AssignmentBasedQueryClientProvider from './QueryClientProvider';
import Table from './Table';
import Header from './Header';

const AssignmentsBasedGradesTable = () => {
  useGradesTableData();

  return (
    <>
      <Header />
      <Navigation />
      <Table />
    </>
  );
};

const AssignmentsBasedGradesTableWrapper = (props: AssignmentsBasedGradesTableProps) => (
  <BrowserRouter basename="/teacher/scores">
    <GradesTableStoreProvider props={props}>
      <AssignmentBasedQueryClientProvider>
        <Routes>
          <Route element={<AssignmentsBasedGradesTable />} path=":classroomId" />
        </Routes>
      </AssignmentBasedQueryClientProvider>
    </GradesTableStoreProvider>
  </BrowserRouter>
);

export default AssignmentsBasedGradesTableWrapper;
